import React, { Component } from 'react';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';

const MARK_NOTIFICATION_AS_READ = gql`
  mutation MarkNotificationsAsRead {
    markNotificationsAsRead {
      isCompleted
    }
  }
`;

export default Comp => {
  /* eslint-disable react/prefer-stateless-function */
  class WithMarkNotificationsAsReadMutation extends Component {
    render() {
      return (
        <Mutation mutation={MARK_NOTIFICATION_AS_READ} onError={() => undefined}>
          {(markNotificationsAsRead, { data, loading, error }) => (
            <Comp
              {...this.props}
              onMarkNotificationsAsRead={markNotificationsAsRead}
              markNotificationsAsReadStatusData={data}
              isLoadingMarkNotificationsAsRead={loading}
              markNotificationsAsReadError={error}
            />
          )}
        </Mutation>
      );
    }
  }
  return WithMarkNotificationsAsReadMutation;
};
